
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useSuperAdminProfile } from '@/hooks/useSuperAdminProfile';
import CurrentPlanCard from '@/components/superadmin/profile/CurrentPlanCard';
import ResourceUsageCards from '@/components/superadmin/profile/ResourceUsageCards';
import AdminInstancesTable from '@/components/superadmin/profile/AdminInstancesTable';
import InviteSuperAdminForm from '@/components/superadmin/profile/InviteSuperAdminForm';

const SuperAdminProfileTab = () => {
  const {
    superAdminProfile,
    isLoading,
    currentPlan,
    resellerPlans,
    isLoadingPlans,
    remainingInstances,
    remainingAdmins,
    handleInviteSuperAdmin
  } = useSuperAdminProfile();

  const onInviteSubmit = async (data: { name: string; email: string; phone: string; }): Promise<boolean> => {
    console.log('SuperAdminProfileTab - Submitting invite:', data);
    const result = await handleInviteSuperAdmin(data);
    console.log('SuperAdminProfileTab - Invite result:', result);
    return result;
  };

  return (
    <div className="space-y-6">
      <Tabs defaultValue="overview" className="w-full">
        <TabsList className="mb-6 border-b">
          <TabsTrigger value="overview">Overview</TabsTrigger>
          <TabsTrigger value="instances">Instances</TabsTrigger>
          <TabsTrigger value="team">Team Management</TabsTrigger>
        </TabsList>
        
        <TabsContent value="overview" className="space-y-6">
          {currentPlan && (
            <CurrentPlanCard 
              planName={currentPlan.name} 
              planId={currentPlan.id}
              description={currentPlan.description}
              features={currentPlan.features || []}
              createdAt={superAdminProfile.createdAt}
            />
          )}
          
          <ResourceUsageCards
            totalInstances={currentPlan?.maxInstances || 0}
            usedInstances={superAdminProfile.instances}
            remainingInstances={remainingInstances}
            totalAdmins={currentPlan?.maxManagers || 0}
            usedAdmins={superAdminProfile.managerCount}
            remainingAdmins={remainingAdmins}
          />
        </TabsContent>
        
        <TabsContent value="instances" className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Your Instances</CardTitle>
            </CardHeader>
            <CardContent>
              <AdminInstancesTable />
            </CardContent>
          </Card>
        </TabsContent>
        
        <TabsContent value="team" className="space-y-6">
          <InviteSuperAdminForm 
            onInvite={onInviteSubmit}
            remainingSlots={remainingAdmins} 
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default SuperAdminProfileTab;
